<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Quarts de travail</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Quarts de travail</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            />
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom du quart de travail"
                                    label="Nom du quart de travail"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.description"
                                    placeholder="Description"
                                    label="Description"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="start_time"
                                    label="Heure de début"
                                    v-model="form.start_time"
                                    mask="time" :rules="['time']"
                                    placeholder="00:00"
                                    :required="true"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="end_time"
                                    label="Heure de fin"
                                    v-model="form.end_time"
                                    mask="time" :rules="['time']"
                                    placeholder="00:00"
                                    :required="true"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Sun"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Dimanche</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Mon"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Lundi</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Tue"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Mardi</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Wed"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Mercredi</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Thu"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Jeudi</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Fri"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Vendredi</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox
                                            size="xs"
                                            dense
                                            v-model="form.Sat"
                                        />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Samedi</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </div>

                            <!-- <div class="o-form__item -button">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->

                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { SHIFTTEMPLATES } from '@/graphql/shift/queries'
    import { UPSERTSHIFTTEMPLATE, DELETESHIFTTEMPLATE, RESTORESHIFTTEMPLATES } from '@/graphql/shift/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: 'shiftTemplates',
        apollo: {
            shifTemplates: {
                query: SHIFTTEMPLATES,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(shiftTemplates) {
                    this.listbox.listItems = Object.assign([], shiftTemplates.shiftTemplates.data)
                    return shiftTemplates;
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchable: 'Rechercher / filtrer'
                },
                form: {},
                newItem: {
                    id: null,
                    name: null,
                    description: null,
                    start_time: null,
                    end_time: null,
                    Sun: false,
                    Mon: true,
                    Tue: true,
                    Wed: true,
                    Thu: true,
                    Fri: true,
                    Sat: false,
                },
                showDeleted: false,
            }
        },
        mounted: async function(){
            this.setNewItem();
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form = Object.assign({}, this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETESHIFTTEMPLATE,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.shiftTemplates) this.$apollo.queries.shiftTemplates.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTSHIFTTEMPLATE,
                    variables: { ...form },
                    update: (store, { data: { upsertShiftTemplate } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed }
                            const data = store.readQuery({ query: SHIFTTEMPLATES, variables: myVariables })
                            data.shiftTemplates.data.push(upsertShiftTemplate);
                            store.writeQuery({
                                query: SHIFTTEMPLATES,
                                data,
                            })
                        }
                        this.setSelected(upsertShiftTemplate)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "ShiftTemplate : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message+'<br>'+e.debugMessage})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORESHIFTTEMPLATES,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { tag } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: SHIFTTEMPLATES })
                            data.shiftTemplates.push(tag);
                            store.writeQuery({
                                query: SHIFTTEMPLATES,
                                data,
                            })
                        }
                        this.setSelected(tag)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
